module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/aaatenBC.afa29f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/aaatenBC.jpg
// module id = GSKn
// module chunks = 0